import { ColDef, GridOptions } from 'ag-grid-community'
import { Locale, Translation } from 'locale'
import { gridOptionsBase, TypedValueGetterParams, ValidationCellRenderer } from 'view/components/datagrid'
import { booleanFormatter } from '../datagrid'
import { PendingTradingRelationship, TradingRelationshipFields } from './validateTradingRelationshipParseResult'

enum PendingTradingRelationshipGridColumnId {
  RELATIONSHIP_ACTION = 'RELATIONSHIP_ACTION',
  BUY_ORGANISATION = 'BUY_ORGANISATION',
  BUY_TRADING_ENTITY = 'BUY_TRADING_ENTITY',
  SELL_ORGANISATION = 'SELL_ORGANISATION',
  SELL_TRADING_ENTITY = 'SELL_TRADING_ENTITY',
  US_SPONSORED_CLEARING = 'US_SPONSORED_CLEARING',
  US_SPONSORED_CLEARING_DEFAULT = 'US_SPONSORED_CLEARING_DEFAULT',
  MASTER_LEGAL_AGREEMENTS = 'MASTER_LEGAL_AGREEMENTS',
  DEFAULT_AGREEMENT = 'DEFAULT_AGREEMENT'
}

export const PendingTradingRelationshipColumnDefs: ColDef[] = [
  {
    colId: PendingTradingRelationshipGridColumnId.RELATIONSHIP_ACTION,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.relationshipAction,
    headerName: Locale.translate(Translation.TC_RELATIONSHIP_ACTION),
    width: 160,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.RELATIONSHIP_ACTION
    }
  },
  {
    colId: PendingTradingRelationshipGridColumnId.BUY_ORGANISATION,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.buyOrganisation,
    headerName: Locale.translate(Translation.TC_BUY_ORGANISATION),
    width: 160,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.BUY_ORGANISATION
    }
  },
  {
    colId: PendingTradingRelationshipGridColumnId.BUY_TRADING_ENTITY,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.buyTradingEntity,
    headerName: Locale.translate(Translation.TC_BUY_TRADING_ENTITY),
    width: 170,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.BUY_TRADING_ENTITY
    }
  },
  {
    colId: PendingTradingRelationshipGridColumnId.SELL_ORGANISATION,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.sellOrganisation,
    headerName: Locale.translate(Translation.TC_SELL_ORGANISATION),
    width: 160,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.SELL_ORGANISATION
    }
  },
  {
    colId: PendingTradingRelationshipGridColumnId.SELL_TRADING_ENTITY,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.sellTradingEntity,
    headerName: Locale.translate(Translation.TC_SELL_TRADING_ENTITY),
    width: 170,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.SELL_TRADING_ENTITY
    }
  },
  {
    colId: PendingTradingRelationshipGridColumnId.US_SPONSORED_CLEARING,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.usSponsoredClearing,
    headerName: Locale.translate(Translation.TC_US_SC_ENABLED),
    width: 120,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.US_SPONSORED_CLEARING
    },
    valueFormatter: booleanFormatter
  },
  {
    colId: PendingTradingRelationshipGridColumnId.US_SPONSORED_CLEARING_DEFAULT,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.usSponsoredClearingDefault,
    headerName: Locale.translate(Translation.TC_US_SC_DEFAULT),
    width: 120,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.US_SPONSORED_CLEARING_DEFAULT
    },
    valueFormatter: booleanFormatter
  },
  {
    colId: PendingTradingRelationshipGridColumnId.MASTER_LEGAL_AGREEMENTS,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.masterLegalAgreements.join(', '),
    headerName: Locale.translate(Translation.TC_MASTER_LEGAL_AGREEMENTS),
    width: 170,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.MASTER_LEGAL_AGREEMENTS
    }
  },
  {
    colId: PendingTradingRelationshipGridColumnId.DEFAULT_AGREEMENT,
    valueGetter: (params: TypedValueGetterParams<PendingTradingRelationship>) => params.data?.defaultAgreement,
    headerName: Locale.translate(Translation.TC_DEFAULT_AGREEMENT),
    width: 150,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingRelationshipFields.DEFAULT_AGREEMENT
    }
  }
]

export const pendingTradingRelationshipGridOptions: GridOptions = {
  ...gridOptionsBase,
  getRowId: ({ data }) => data.idx
}
